<script src="../../router/private/order.js"></script>
<template>
  <oil-form v-if="loading"
    title='СОЗДАТЬ ЗАЯВКУ'
    :keys='formKeys'
    :items='order'
    :createForm='true'
    :formCallback='formCallback'
    @AppendixId='Appendix'
    @EmpowermentId='Empowerment'
    @ClosedAmountInTonne='calculateTonne'
    @Density='calculateDensity'
  >
    <template v-slot:Buyer.Id='{rules}'>
      <v-autocomplete
        :items='buyers$'
        v-stream:keyup.native='searchCompany$'
        hide-no-data
        class='z-index'
        clearable
        :rules='[...rules]'
        dense
        outlined
        @change='Buyer'
        hide-selected
        :value='order.Buyer.CompanyName'
        item-text='CompanyName'
        label='Выбрать покупателя'
        return-object
      ></v-autocomplete>
    </template>
    <template v-slot:Contract.Id='{rules}'>
      <v-autocomplete
        :items='contracts$'
        v-stream:keyup.native='searchContract$'
        hide-no-data
        class='z-index'
        :rules='[...rules]'
        clearable
        @change='Contract'
        dense
        outlined
        :value='order.Contract.Number'
        hide-selected
        item-text='Number'
        label='Выбрать договор'
        return-object
      ></v-autocomplete>
    </template>

    <template v-slot:RemainingVolume>
      <v-text-field
        label='Остаток в литрах'
        background-color='#709b60'
        outlined
        filled
        dense
        readonly
      >
      </v-text-field>
    </template>

  </oil-form>
</template>

<script>

//services
import { companiesService } from '@/services/CompaniesService'
import { orderService } from '@/services/OrderService'
import create from './globalFunctionsInThisDirectory.js'

export default {
  mixins: [create],


  async created() {

    this.resetAll()
    const companies = await companiesService.getAll()
    this.buyers$ = companies.data || []
    this.loading = true
  },
  methods: {

    async formCallback(order, input,form,func) {
      input.isEdit = false
      const response = await orderService.create(order)
      this.$notify({
        group: 'mgs',
        type: 'success',
        title: 'заявка удачно создан',
        timestamp: 2000
      })
      const id = response.data?.Id

      if (id) {
        await this.$router.push({
          name: 'order-update',
          params: { id: id }
        })
      }
    },

    calculateTonne(liter) {
      const result = this.order.ClosedAmountInTonne * this.order.Density
      let res = parseFloat(result).toFixed(4)
      if (isNaN(res)) {
        res = 0
      }
      this.order.GrossPerTonne = res
    },


    //objects
    async Buyer(buyer) {
      if (!buyer) return
      this.resetAll(false)
      this.order.Buyer = { ...buyer }
    },
    Contract(contract) {
      if (!contract) return
      this.order.Contract = contract
    },
    Appendix(appendix) {
      if (!appendix) return
      this.order.Appendix = { ...appendix }
      this.order.AppendixNumber = appendix.Number
      this.order.Item = { ...appendix.Item }
    },
    Empowerment(empowerment) {
      if (!empowerment) return
      this.order.Empowerment = { ...empowerment }
    }

  },
  watch: {}
}
</script>
